import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react'
import Cookies from 'js-cookie'
import ReactSlider from 'react-slider'
import styled from 'styled-components'
import axios from 'axios'

import { ReactComponent as SVG_Heart  } from './heart.svg'
import { ReactComponent as SVG_Arrow  } from './arrow_left.svg'
import { ReactComponent as SVG_Check  } from './check.svg'

// ─── Data ────────────────────────────────────────────────────────────────────

const APARTMENTS = [
  // Building B - Floor 0
  {id:1,  building:'B', name:'B0-01', size:35.04, floor:0, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:2,  building:'B', name:'B0-02', size:65.38, floor:0, rooms:3, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:3,  building:'B', name:'B0-03', size:33.83, floor:0, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:4,  building:'B', name:'B0-04', size:36.45, floor:0, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:5,  building:'B', name:'B0-05', size:42.18, floor:0, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:6,  building:'B', name:'B0-06', size:43.87, floor:0, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:7,  building:'B', name:'B0-07', size:57.1,  floor:0, rooms:2, parking:true,  available:true,  status:'Zapytaj',   favorite:false},
  {id:8,  building:'B', name:'B0-08', size:69.87, floor:0, rooms:3, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:9,  building:'B', name:'B0-09', size:43.02, floor:0, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:10, building:'B', name:'B0-10', size:27.43, floor:0, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:11, building:'B', name:'B0-11', size:48.66, floor:0, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:12, building:'B', name:'B0-12', size:38.52, floor:0, rooms:2, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:13, building:'B', name:'B0-13', size:25.61, floor:0, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:14, building:'B', name:'B0-14', size:26.05, floor:0, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:15, building:'B', name:'B0-15', size:26.05, floor:0, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:16, building:'B', name:'B0-16', size:26.05, floor:0, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:17, building:'B', name:'B0-17', size:25.98, floor:0, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  // Building B - Floor 1
  {id:18, building:'B', name:'B1-01', size:54.05,  floor:1, rooms:3, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:19, building:'B', name:'B1-02', size:43.84,  floor:1, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:20, building:'B', name:'B1-03', size:80.45,  floor:1, rooms:3, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:21, building:'B', name:'B1-04', size:72.35,  floor:1, rooms:3, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:22, building:'B', name:'B1-05', size:65.38,  floor:1, rooms:3, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:23, building:'B', name:'B1-06', size:33.83,  floor:1, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:24, building:'B', name:'B1-07', size:36.45,  floor:1, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:25, building:'B', name:'B1-08', size:54.10,  floor:1, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:26, building:'B', name:'B1-09', size:101.31, floor:1, rooms:4, parking:true,  available:true,  status:'Zapytaj',   favorite:false},
  {id:27, building:'B', name:'B1-10', size:69.87,  floor:1, rooms:3, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:28, building:'B', name:'B1-11', size:43.02,  floor:1, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:29, building:'B', name:'B1-12', size:43.83,  floor:1, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:30, building:'B', name:'B1-13', size:48.66,  floor:1, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:31, building:'B', name:'B1-14', size:40.34,  floor:1, rooms:2, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:32, building:'B', name:'B1-15', size:27.88,  floor:1, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:33, building:'B', name:'B1-16', size:27.88,  floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:34, building:'B', name:'B1-17', size:27.88,  floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:35, building:'B', name:'B1-18', size:27.88,  floor:1, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:36, building:'B', name:'B1-19', size:42.11,  floor:1, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:37, building:'B', name:'B1-20', size:42.11,  floor:1, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:38, building:'B', name:'B1-21', size:26.27,  floor:1, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:39, building:'B', name:'B1-22', size:45.51,  floor:1, rooms:2, parking:false, available:true,  status:'Dostępny',   favorite:false},
  // Building B - Floor 2
  {id:40, building:'B', name:'B2-01', size:54.09, floor:2, rooms:3, parking:true,  available:true,  status:'Zapytaj',    favorite:false},
  {id:41, building:'B', name:'B2-02', size:43.11, floor:2, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:42, building:'B', name:'B2-03', size:80.37, floor:2, rooms:3, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:43, building:'B', name:'B2-04', size:73.58, floor:2, rooms:3, parking:false, available:true,  status:'Zapytaj',    favorite:false},
  {id:44, building:'B', name:'B2-05', size:64.29, floor:2, rooms:3, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:45, building:'B', name:'B2-06', size:33.79, floor:2, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:46, building:'B', name:'B2-07', size:38.60, floor:2, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:47, building:'B', name:'B2-08', size:69.17, floor:2, rooms:3, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:48, building:'B', name:'B2-09', size:74.96, floor:2, rooms:3, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:49, building:'B', name:'B2-10', size:69.06, floor:2, rooms:3, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:50, building:'B', name:'B2-11', size:43.02, floor:2, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:51, building:'B', name:'B2-12', size:43.81, floor:2, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:52, building:'B', name:'B2-13', size:48.63, floor:2, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:53, building:'B', name:'B2-14', size:40.32, floor:2, rooms:2, parking:true,  available:false, status:'Rezerwacja', favorite:false, reservation:true},
  {id:54, building:'B', name:'B2-15', size:27.86, floor:2, rooms:1, parking:false, available:false, status:'Rezerwacja', favorite:false, reservation:true},
  {id:55, building:'B', name:'B2-16', size:27.86, floor:2, rooms:1, parking:false, available:false, status:'Rezerwacja', favorite:false, reservation:true},
  {id:56, building:'B', name:'B2-17', size:27.38, floor:2, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:57, building:'B', name:'B2-18', size:27.38, floor:2, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:58, building:'B', name:'B2-19', size:42.48, floor:2, rooms:2, parking:true,  available:false, status:'Rezerwacja', favorite:false, reservation:true},
  {id:59, building:'B', name:'B2-20', size:42.08, floor:2, rooms:2, parking:true,  available:false, status:'Rezerwacja', favorite:false, reservation:true},
  {id:60, building:'B', name:'B2-21', size:26.25, floor:2, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:61, building:'B', name:'B2-22', size:45.51, floor:2, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  // Building B - Floor 3
  {id:62, building:'B', name:'B3-01', size:61.4,   floor:3, rooms:3, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:63, building:'B', name:'B3-02', size:100.01, floor:3, rooms:3, parking:true,  available:true,  status:'Sprzedany',  favorite:false},
  {id:64, building:'B', name:'B3-03', size:74.77,  floor:3, rooms:3, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:65, building:'B', name:'B3-04', size:47.49,  floor:3, rooms:3, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:66, building:'B', name:'B3-05', size:33.76,  floor:3, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:67, building:'B', name:'B3-06', size:38.57,  floor:3, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:68, building:'B', name:'B3-07', size:42.20,  floor:3, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:69, building:'B', name:'B3-08', size:76.33,  floor:3, rooms:3, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:70, building:'B', name:'B3-09', size:52.79,  floor:3, rooms:2, parking:false, available:true,  status:'Zapytaj',   favorite:false},
  {id:71, building:'B', name:'B3-10', size:42.98,  floor:3, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:72, building:'B', name:'B3-11', size:43.79,  floor:3, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:73, building:'B', name:'B3-12', size:48.63,  floor:3, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:74, building:'B', name:'B3-13', size:40.29,  floor:3, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:75, building:'B', name:'B3-14', size:27.81,  floor:3, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:76, building:'B', name:'B3-15', size:27.81,  floor:3, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:77, building:'B', name:'B3-16', size:27.81,  floor:3, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:78, building:'B', name:'B3-17', size:27.81,  floor:3, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:79, building:'B', name:'B3-18', size:27.81,  floor:3, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:80, building:'B', name:'B3-19', size:42.01,  floor:3, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:81, building:'B', name:'B3-20', size:26.21,  floor:3, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:82, building:'B', name:'B3-21', size:32.1,   floor:3, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  // Building A - Floor 1
  {id:83,  building:'A', name:'A1-01', size:45.99, terrace:21.40, floor:1, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:84,  building:'A', name:'A1-02', size:28.56, floor:1, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:85,  building:'A', name:'A1-03', size:29.05, floor:1, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:86,  building:'A', name:'A1-04', size:28.56, floor:1, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:87,  building:'A', name:'A1-05', size:60.67, floor:1, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:88,  building:'A', name:'A1-06', size:48.82, floor:1, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:89,  building:'A', name:'A1-07', size:29.62, floor:1, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:90,  building:'A', name:'A1-08', size:54.10, floor:1, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:91,  building:'A', name:'A1-09', size:29.74, floor:1, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:92,  building:'A', name:'A1-10', size:44.97, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:93,  building:'A', name:'A1-11', size:56.43, floor:1, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:94,  building:'A', name:'A1-12', size:52.96, floor:1, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:95,  building:'A', name:'A1-13', size:37.66, floor:1, rooms:1, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:96,  building:'A', name:'A1-14', size:31.55, floor:1, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:97,  building:'A', name:'A1-15', size:30.48, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:98,  building:'A', name:'A1-16', size:41.28, floor:1, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:99,  building:'A', name:'A1-17', size:51.26, floor:1, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:100, building:'A', name:'A1-18', size:29.05, floor:1, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:101, building:'A', name:'A1-19', size:29.05, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:102, building:'A', name:'A1-20', size:29.06, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:103, building:'A', name:'A1-21', size:27.9,  floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:104, building:'A', name:'A1-22', size:28.86, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:105, building:'A', name:'A1-23', size:30.48, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:106, building:'A', name:'A1-24', size:30.48, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:107, building:'A', name:'A1-25', size:36.22, floor:1, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  // Building A - Floor 2
  {id:108, building:'A', name:'A2-01', size:45.21, floor:2, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:109, building:'A', name:'A2-02', size:29.05, floor:2, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:110, building:'A', name:'A2-03', size:28.56, floor:2, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:111, building:'A', name:'A2-04', size:29.05, floor:2, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:112, building:'A', name:'A2-05', size:60.34, floor:2, rooms:2, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:113, building:'A', name:'A2-06', size:48.80, floor:2, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:114, building:'A', name:'A2-07', size:29.62, floor:2, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:115, building:'A', name:'A2-08', size:54.04, floor:2, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:116, building:'A', name:'A2-09', size:29.74, floor:2, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:117, building:'A', name:'A2-10', size:37.30, floor:2, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:118, building:'A', name:'A2-11', size:62.09, floor:2, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:119, building:'A', name:'A2-12', size:52.70, floor:2, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:120, building:'A', name:'A2-13', size:37.03, floor:2, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:121, building:'A', name:'A2-14', size:31.55, floor:2, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:122, building:'A', name:'A2-15', size:30.48, floor:2, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:123, building:'A', name:'A2-16', size:41.28, floor:2, rooms:2, parking:true,  available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:124, building:'A', name:'A2-17', size:50.40, floor:2, rooms:2, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:125, building:'A', name:'A2-18', size:29.05, floor:2, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:126, building:'A', name:'A2-19', size:29.05, floor:2, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:127, building:'A', name:'A2-20', size:29.05, floor:2, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:128, building:'A', name:'A2-21', size:27.90, floor:2, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:129, building:'A', name:'A2-22', size:28.86, floor:2, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:130, building:'A', name:'A2-23', size:30.48, floor:2, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:131, building:'A', name:'A2-24', size:30.48, floor:2, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:132, building:'A', name:'A2-25', size:36.22, floor:2, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  // Building A - Floor 3
  {id:133, building:'A', name:'A3-01', size:36.18,  floor:3, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:134, building:'A', name:'A3-02', size:28.56,  floor:3, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:135, building:'A', name:'A3-03', size:28.56,  floor:3, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:136, building:'A', name:'A3-04', size:112.93, floor:3, rooms:3, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:137, building:'A', name:'A3-05', size:29.62,  floor:3, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:138, building:'A', name:'A3-06', size:53.11,  floor:3, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:139, building:'A', name:'A3-07', size:29.80,  floor:3, rooms:1, parking:true,  available:false, status:'Sprzedany',  favorite:false},
  {id:140, building:'A', name:'A3-08', size:34.69,  floor:3, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:141, building:'A', name:'A3-09', size:117.01, floor:3, rooms:4, parking:false, available:true,  status:'Zapytaj',   favorite:false},
  {id:142, building:'A', name:'A3-10', size:47.5,   floor:3, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:143, building:'A', name:'A3-11', size:30.48,  floor:3, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:144, building:'A', name:'A3-12', size:41.28,  floor:3, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:145, building:'A', name:'A3-13', size:51.27,  floor:3, rooms:2, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:146, building:'A', name:'A3-14', size:29.05,  floor:3, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:147, building:'A', name:'A3-15', size:29.05,  floor:3, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:148, building:'A', name:'A3-16', size:29.05,  floor:3, rooms:1, parking:false, available:true,  status:'Rezerwacja', favorite:false, reservation:true},
  {id:149, building:'A', name:'A3-17', size:27.91,  floor:3, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:150, building:'A', name:'A3-18', size:28.86,  floor:3, rooms:1, parking:false, available:true,  status:'Dostępny',   favorite:false},
  {id:151, building:'A', name:'A3-19', size:29.97,  floor:3, rooms:1, parking:false, available:false, status:'Sprzedany',  favorite:false},
  {id:152, building:'A', name:'A3-20', size:30.48,  floor:3, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
  {id:153, building:'A', name:'A3-21', size:36.22,  floor:3, rooms:1, parking:true,  available:true,  status:'Dostępny',   favorite:false},
]





// ─── Colors ──────────────────────────────────────────────────────────────────

const STATUS_COLORS = {
  Rezerwacja: { fill:'rgba(255,255,0,0.4)',   hover:'rgba(255,255,0,0.1)',   leave:'rgba(255,255,0,0.3)'   },
  Dostępny:   { fill:'rgba(51,242,95,0.4)',   hover:'rgba(51,242,95,0.1)',   leave:'rgba(51,242,95,0.3)'   },
  Sprzedany:  { fill:'rgba(255,255,255,0.4)', hover:'rgba(0,0,0,0.1)',       leave:'rgba(255,255,255,0.3)' },
  Zapytaj:    { fill:'rgba(255,140,0,0.4)',   hover:'rgba(255,140,0,0.1)',   leave:'rgba(255,140,0,0.3)'   },
}
const getStatusColor = (status, type) => STATUS_COLORS[status]?.[type] ?? 'rgba(255,255,255,0.3)'

// ─── Polygon data ─────────────────────────────────────────────────────────────

// Geometry shared across Building A floors
const AS = {
  r20: "56,54 60.5,54 60.5,68 56,68",
  r19: "60.5,54 65.5,54 65.5,68 60.5,68",
  r18: "65.5,54 70.5,54 70.5,68 65.5,68",
  r17: "70.5,54 69.5,50.5 75.5,52.75 75,56 82.5,59 79.75,68 70.5,68",
  r16: "71.5,46 85.5,50.5 82.5,59 75,56 75.5,53 69.5,50.5",
  r15: "73,41.5 87,46 85.5,50.5 71.5,46",
  r14: "74.75,36.5 81.5,39 87.5,38 88,42 87,46 73,41",
  r13: "74,31.5 85.5,29 87.5,38 82,39 74.75,36.5",
  r12: "72,24 74.75,23.75 73.5,17 83,17.5 85.5,29 74,31.25",
  r8:  "47,32 51,29 53.5,30.5 55,30 57,37.75 55,38.5 55.5,42.5 48,44 44.5,39.5 50,35",
  r7:  "38.5,33 47.5,25 51,28.5 42,37",
  r5:  "37,27 23.5,25 22.25,29.75 36,32",
  r4:  "22.25,29.75 36,32 35,37 22,34.75",
  r3:  "22,34.75 35,37 34.5,41.75 21,39.5",
  r2:  "21,39.5 36.5,41.75 36.5,44.75 30.5,50.75 19.5,48.5",
  r25: "46,44.5 44,43 36.5,41.75 36.5,44.75 30.5,50.75 34.5,54",
  r24: "49,48 46,44.75 34.5,54 37.5,58",
  r23: "49,48 37.5,58 41,61.5 52,52",
  r22: "44.25,65.25 54,57 54,55 52,52 41,61.5",
  r21: "44.25,65.25 54,57 54,55 56,55 56,68 46.75,68",
}

// Geometry shared across Building B floors
const BS = {
  b19: "39,58.25 44.25,58.25 44.25,53.5 50.5,53.5 50.5,69.75 39,69.75",
  b18: "50.5,53.5 56.5,53.5 56.5,69.75 50.5,69.75",
  b17: "56.5,53.5 62.5,53.5 62.5,69.75 56.5,69.75",
  b16: "62.5,53.5 69,53.5 69,69.75 62.5,69.75",
  b15: "69,53.5 75,53.5 75,69.75 69,69.75",
  b14: "75,53.5 81,53.5 81,58.25 85.75,58.25 85.75,53.5 85.75,69.75 75,69.75",
  b13: "98.75,56.5 83.5,50.5 82.5,53.5 81,53.5 81,58.25 85.75,58.25 85.75,69.75 93.5,69.75",
  b12: "98.75,56.5 83.5,50.5 87,42 102.25,47.75",
  b11: "104,38.5 91,33 87,42 102.25,47.75",
}

const FLOOR_POLYGONS = {
  'A-1': [
    {id:102,points:AS.r20}, {id:101,points:AS.r19}, {id:100,points:AS.r18}, {id:99,points:AS.r17},
    {id:98,points:AS.r16},  {id:97,points:AS.r15},  {id:96,points:AS.r14},  {id:95,points:AS.r13},
    {id:94,points:AS.r12},
    {id:93,points:"63,27.5 67,16.5 73.5,17 74.75,23.5 72.25,24 72.25,27 71,27 71.5,31.25 66.5,32.25 65.5,28.5"},
    {id:92,points:"63,41 60,29 62.5,28.5 64,28 65,28 66,32 71.25,31 72.25,34.5 65.25,36 66,40"},
    {id:91,points:"55,30 60,29 63,41 55.75,42.5 55,38.5 57,38"},
    {id:90,points:AS.r8},   {id:89,points:AS.r7},
    {id:88,points:"36.5,14.5 38.5,14.5 47.5,25 38.5,32.5 39.75,25 36.5,21.5 35.5,21.25"},
    {id:87,points:"25,14 36,14.25 35.5,21.25 38.5,24 37,27 23.5,25"},
    {id:86,points:AS.r5},   {id:85,points:AS.r4},   {id:84,points:AS.r3},   {id:83,points:AS.r2},
    {id:107,points:AS.r25}, {id:106,points:AS.r24}, {id:105,points:AS.r23}, {id:104,points:AS.r22}, {id:103,points:AS.r21},
  ],
  'A-2': [
    {id:127,points:AS.r20}, {id:126,points:AS.r19}, {id:125,points:AS.r18}, {id:124,points:AS.r17},
    {id:123,points:AS.r16}, {id:122,points:AS.r15}, {id:121,points:AS.r14}, {id:120,points:AS.r13},
    {id:119,points:AS.r12},
    {id:118,points:"63,27.5 67,16.5 73.5,17 74.75,23.5 72.25,24 72.25,27 71,27 72,34.5 68.5,35.5 68,32 66.5,32.25 65.5,28.5"},
    {id:117,points:"60.5,41.5 59.75,37 62,36.5 60,29 62.5,28.5 64,28 65,28 66,32 68,32 68.25,35.5 65.25,36 66,40"},
    {id:116,points:"55,30 60,29 61.5,36.75 59.75,37.25 60.25,41.25 55.75,42.5 55,38.5 57,38"},
    {id:115,points:AS.r8},  {id:114,points:AS.r7},
    {id:113,points:"36.5,14.5 38.5,14.5 47.5,25 38.5,32.5 39.75,25 36.5,21.5 35.5,21.25"},
    {id:112,points:"25,14 36,14.25 35.5,21.25 38.5,24 37,27 23.5,25"},
    {id:111,points:AS.r5},  {id:110,points:AS.r4},  {id:109,points:AS.r3},  {id:108,points:AS.r2},
    {id:132,points:AS.r25}, {id:131,points:AS.r24}, {id:130,points:AS.r23}, {id:129,points:AS.r22}, {id:128,points:AS.r21},
  ],
  'A-3': [
    {id:148,points:AS.r20}, {id:147,points:AS.r19}, {id:146,points:AS.r18}, {id:145,points:AS.r17},
    {id:144,points:AS.r16}, {id:143,points:AS.r15},
    {id:142,points:"74.75,36.5 86.5,33.5 88,42 87,46 73,41"},
    {id:141,points:"63,27.5 67,16.5 83,17.5 86.5,33.75 72,37 72,34.5 67,35.5 66.5,32.25 65.5,28.5"},
    {id:140,points:"60.5,41.5 59.75,37 62,36.5 60,29 62.5,28.5 64,28 65,28 66,32 67,35.5 65.25,36 66,40"},
    {id:139,points:"55,30 60,29 61.5,36.75 59.75,37.25 60.25,41.25 55.75,42.5 55,38.5 57,38"},
    {id:138,points:AS.r8},  {id:137,points:AS.r7},
    {id:136,points:"48,25 42.75,15 25.5,14 22.25,29.75 39,32"},
    {id:135,points:AS.r4},  {id:134,points:AS.r3},  {id:133,points:AS.r2},
    {id:153,points:AS.r25}, {id:152,points:AS.r24}, {id:151,points:AS.r23}, {id:150,points:AS.r22}, {id:149,points:AS.r21},
  ],
  'B-0': [
    {id:17,points:"44.25,69.75 44.25,53.5 50.5,53.5 50.5,69.75"},
    {id:16,points:BS.b18},  {id:15,points:BS.b17},  {id:14,points:BS.b16},  {id:13,points:BS.b15},
    {id:12,points:BS.b14},  {id:11,points:BS.b13},  {id:9,points:BS.b11},
    {id:8, points:"97.5,15.5 108,16 104,38.5 91,33"},
    {id:7, points:"97.5,15.5 78.25,14 75.25,21.25 85.75,25.25 84.75,27.25 89.25,29.25 89.5,27.5 92.5,28.5"},
    {id:6, points:"87.75,32 89.25,29.25 84.75,27.25 85.75,25.25 75.25,21.25 70.75,32 85.5,37.75"},
    {id:5, points:"83.5,43 68,43 68,34.5 69.75,34.5 70.75,32 85.5,37.75"},
    {id:4, points:"68,43 68,34.5 62.5,34.5 62.5,51 73,51 73,43"},
    {id:3, points:"57.25,43.5 57.25,34.5 62.5,34.5 62.5,51 53.5,51 53.5,43.5"},
    {id:2, points:"53.5,26.5 57.25,34.5 57.25,43.5 43,43.5 38.5,32.5"},
    {id:1, points:"36,27 40.25,25 39.25,22.5 50.25,18 53.5,26.5 38.5,32.5"},
  ],
  'B-1': [
    {id:39,points:"29,49.5 40.5,44.5 42.5,50.5 27.75,56.5 26,52 29,51"},
    {id:38,points:"29,49.5 40.5,44.5 38,38.5 29,42 25,41 22.5,40 19,49.5 26,52 29,51"},
    {id:37,points:"39,70 39,58.25 44,58.25 44,53.5 42.5,50.5 27.75,56.5 33.25,70"},
    {id:36,points:BS.b19},  {id:35,points:BS.b18},  {id:34,points:BS.b17},  {id:33,points:BS.b16},
    {id:32,points:BS.b15},  {id:31,points:BS.b14},  {id:30,points:BS.b13},  {id:29,points:BS.b12},  {id:28,points:BS.b11},
    {id:27,points:"97.5,15.5 108,16 104,38.5 91,33"},
    {id:26,points:"97.5,15.5 78.25,14 70.75,32 85.5,37.75 89.5,27.5 92.5,28.5"},
    {id:25,points:"83.5,43 68,43 68,34.5 69.75,34.5 70.75,32 85.5,37.75"},
    {id:24,points:"68,43 68,34.5 62.5,34.5 62.5,51 73,51 73,43"},
    {id:23,points:"57.25,43.5 57.25,34.5 62.5,34.5 62.5,51 53.5,51 53.5,43.5"},
    {id:22,points:"53.5,26.5 57.25,34.5 57.25,43.5 43,43.5 38.5,32.5"},
    {id:21,points:"33.5,20.75 36.5,11.75 48,12.5 53.5,26.5 38.5,32.5"},
    {id:20,points:"31.5,33 35.5,31.5 34.5,29 36.75,28 34,20.5 36.5,11.75 17.75,10.75 14.5,21 29.5,26 29.25,28"},
    {id:19,points:"14.5,21 11.5,30 27,35 30,26"},
    {id:18,points:"6.5,45.5 11.5,30 27,35 25,41 22.5,40 19,49.5"},
  ],
  'B-2': [
    {id:61,points:"29,49.5 40.5,44.5 42.5,50.5 27.75,56.5 26,52 29,51"},
    {id:60,points:"29,49.5 40.5,44.5 38,38.5 29,42 25,41 22.5,40 19,49.5 26,52 29,51"},
    {id:59,points:"39,70 39,58.25 44,58.25 44,53.5 42.5,50.5 27.75,56.5 33.25,70"},
    {id:58,points:BS.b19},  {id:57,points:BS.b18},  {id:56,points:BS.b17},  {id:55,points:BS.b16},
    {id:54,points:BS.b15},  {id:53,points:BS.b14},  {id:52,points:BS.b13},  {id:51,points:BS.b12},  {id:50,points:BS.b11},
    {id:49,points:"97.5,15.5 108,16 104,38.5 91,33"},
    {id:48,points:"97.5,15.5 78.25,14 73.25,26.5 87.75,32 89.5,27.5 92.5,28.5"},
    {id:47,points:"83.5,43 68,43 68,34.5 70,34.5 73.25,26.5 87.75,32"},
    {id:46,points:"68,43 68,34.5 62.5,34.5 62.5,51 73,51 73,43"},
    {id:45,points:"57.25,43.5 57.25,34.5 62.5,34.5 62.5,51 53.5,51 53.5,43.5"},
    {id:44,points:"53.5,26.5 57.25,34.5 57.25,43.5 43,43.5 38.5,32.5"},
    {id:43,points:"33.5,20.75 36.5,11.75 48,12.5 53.5,26.5 38.5,32.5"},
    {id:42,points:"31.5,33 35.5,31.5 34.5,29 36.75,28 34,20.5 36.5,11.75 17.75,10.75 14.5,21 29.5,26 29.25,28"},
    {id:41,points:"14.5,21 11.5,30 27,35 30,26"},
    {id:40,points:"6.5,45.5 11.5,30 27,35 25,41 22.5,40 19,49.5"},
  ],
  'B-3': [
    {id:81,points:"29,49.5 40.5,44.5 42.5,50.5 27.75,56.5 26,52 29,51"},
    {id:82,points:"29,49.5 40.5,44.5 38,38.5 29,42 27.25,41.5 24,51.5 26,52 29,51"},
    {id:80,points:"39,70 39,58.25 44,58.25 44,53.5 42.5,50.5 27.75,56.5 33.25,70"},
    {id:79,points:BS.b19},  {id:78,points:BS.b18},  {id:77,points:BS.b17},  {id:76,points:BS.b16},
    {id:75,points:BS.b15},  {id:74,points:BS.b14},  {id:73,points:BS.b13},  {id:72,points:BS.b12},  {id:71,points:BS.b11},
    {id:70,points:"94.5,22.5 95.75,15.5 108,16 104,38.5 91,33"},
    {id:69,points:"94.5,22.5 95.75,15.5 78.25,14 71.25,31.5 85.75,37.5 89.5,27.5 92.5,28.5"},
    {id:68,points:"83.5,43 68,43 68,34.5 70,34.5 71.25,31.5 85.75,37.5"},
    {id:67,points:"68,43 68,34.5 62.5,34.5 62.5,51 73,51 73,43"},
    {id:66,points:"57.25,43.5 57.25,34.5 62.5,34.5 62.5,51 53.5,51 53.5,43.5"},
    {id:65,points:"55.5,31.5 57.25,34.5 57.25,43.5 43,43.5 38.5,32.5 42.25,31.25 44,35.5"},
    {id:64,points:"34.5,23.5 35.5,11.75 48,12.5 55.5,31.5 44,35.5 42.25,31.25 38.5,32.5"},
    {id:63,points:"11.5,30 27,35 31,33.25 31.75,35 36,33.25 33.5,27 35.75,26 34.5,23.5 35.5,11.75 17.75,10.75 14.5,21"},
    {id:62,points:"6.5,45.5 11.5,30 27,35 22,50.5"},
  ],
}

// Overview floor zones on the building exterior image
const OVERVIEW_ZONES = [
  {building:'B', floor:0, points:"-19,55 15,56 24,57 37,57 57,57 57,60.5 -19,62"},
  {building:'B', floor:1, points:"-19,50 13.5,51.5 13.5,53 24,53.5 37,53 57,53.5 57,57 24,57 15,56 -19,55"},
  {building:'B', floor:2, points:"-19,45 13.5,47.5 13.5,49.25 24,49.75 37,49 57,50.5 57,53.5 37,53 24,53.5 13,52.75 13,51.25 -19,50"},
  {building:'B', floor:3, points:"-19,40 12,43.5 12,45.25 24,45.75 36,45.25 54,47 57,50.25 37,49 24,49.5 13,49.25 13,47.25 -19,45"},
  {building:'A', floor:1, points:"57,54.5 66,54.25 89,55 95,55.5 95,58 57,57"},
  {building:'A', floor:2, points:"57,51.5 66,51.25 89,52 95,52.5 95,55 57,54"},
  {building:'A', floor:3, points:"57,49 66,48.5 89,50 95,50.5 95,52.5 89,52 66,51.25 57,51.5"},
]

// ─── Styled components (module-level, not inside render) ─────────────────────

const StyledSlider = styled(ReactSlider)`height: 2px; padding: 0 .5em;`
const StyledThumb  = styled.div`
  height:16px; width:16px; position:absolute; top:-8px;
  background:#C3A478; border-radius:100%; cursor:grab;
`
const StyledTrack  = styled.div`
  top:0; bottom:0;
  background:${p => p.index === 1 ? '#C3A478' : '#ddd'};
`
const SliderThumb = (props) => <StyledThumb {...props} />
const SliderTrack = (props, state) => <StyledTrack {...props} index={state.index} />

// ─── Helpers ─────────────────────────────────────────────────────────────────

const DEFAULT_FILTERS = { favorite:false, parking:false, size:[25,120], floor:[0,3], rooms:[1,4] }

function applyFilters(apts, filters, building) {
  let r = [...apts]
  if (building === 'Budynek A') r = r.filter(a => a.building === 'A')
  if (building === 'Budynek B') r = r.filter(a => a.building === 'B')
  r = r.filter(a =>
    a.size  >= filters.size[0]  && a.size  <= filters.size[1]  &&
    a.rooms >= filters.rooms[0] && a.rooms <= filters.rooms[1] &&
    a.floor >= filters.floor[0] && a.floor <= filters.floor[1]
  )
  if (filters.favorite) r = r.filter(a => a.favorite)
  if (filters.parking)  r = r.filter(a => a.parking)
  return r
}

function applyFavorites(apts, ids) {
  return apts.map(a => ({ ...a, favorite: ids.includes(a.id) }))
}

function endsWith234(n) {
  const d = Math.abs(n) % 10
  return n >= 5 && n <= 10 ? false : [2,3,4].includes(d)
}

// ─── Sub-components ───────────────────────────────────────────────────────────

function FloorPolygon({ apt, points, onPreview, onTooltip, onTooltipHide }) {
  if (!apt) return null
  return (
    <polygon
      style={{ cursor:'pointer' }}
      points={points}
      fill={getStatusColor(apt.status, 'fill')}
      onClick={() => onPreview(apt)}
      onMouseEnter={e => { e.currentTarget.setAttribute('fill', getStatusColor(apt.status, 'hover')); onTooltip(e, apt.status) }}
      onMouseLeave={e => { e.currentTarget.setAttribute('fill', getStatusColor(apt.status, 'leave')); onTooltipHide() }}
      onMouseMove={e  => onTooltip(e, apt.status)}
    />
  )
}

function FloorMap({ scopedFloor, dimensions, apartments, onPreview, onTooltip, onTooltipHide }) {
  const [building, floor] = scopedFloor
  const polygons = FLOOR_POLYGONS[`${building}-${floor}`] ?? []
  const aptMap   = useMemo(() => Object.fromEntries(apartments.map(a => [a.id, a])), [apartments])

  const isA = building === 'A'
  const viewBox  = isA ? "0 -3 84 84" : "0 -5 100 100"
  const svgStyle = isA
    ? { position:'absolute', top:-dimensions.width*0.073, left:-dimensions.width*0.067, width:dimensions.width, height:dimensions.height }
    : { position:'absolute', top:0, left:0, width:dimensions.width, height:dimensions.height }

  return (
    <svg viewBox={viewBox} preserveAspectRatio="xMidYMid meet" style={svgStyle}>
      {polygons.map(({ id, points }) => (
        <FloorPolygon key={id} apt={aptMap[id]} points={points}
          onPreview={onPreview} onTooltip={onTooltip} onTooltipHide={onTooltipHide} />
      ))}
    </svg>
  )
}

function BuildingOverview({ imgRef, onLoad, onSelectFloor }) {
  const HOVER   = 'rgba(239,212,83,0.75)'
  const DEFAULT = 'rgba(255,255,255,0.3)'
  return (
    <>
      <img src="bg1.png" ref={imgRef} onLoad={onLoad}
        style={{ width:'100%', height:'auto', objectFit:'contain' }} alt="Building" />
      <svg viewBox="0 0 100 100" preserveAspectRatio="xMidYMid meet"
        style={{ position:'absolute', top:0, left:0, width:'100%', height:'100%' }}>
        {OVERVIEW_ZONES.map(({ building, floor, points }) => (
          <polygon key={`${building}-${floor}`} points={points} fill={DEFAULT} style={{ cursor:'pointer' }}
            onMouseEnter={e => e.currentTarget.setAttribute('fill', HOVER)}
            onMouseLeave={e => e.currentTarget.setAttribute('fill', DEFAULT)}
            onClick={() => onSelectFloor(building, floor)} />
        ))}
      </svg>
    </>
  )
}

const tdStyle = { padding:'10px', border:'1px solid #ccc', fontSize:'14px', textAlign:'center' }

function PreviewPanel({ apt, onClose, onCompare, onFavorite }) {
  if (!apt) return null
  const rows = [
    ['Apartament',         apt.name],
    ['Powierzchnia',       <>{apt.size} m<sup>2</sup></>],
    ['Piętro',             apt.floor],
    ['Pokoje',             apt.rooms],
    ['Miejsce parkingowe', apt.parking ? 'Tak' : 'Nie'],
  ]
  return (
    <div style={{ width:500, height:'100vh', display:'flex', flexDirection:'column', background:'#f3f3f3', overflow:'auto' }}>
      <div className="pre_section" style={{ position:'sticky', top:0, zIndex:10 }}>
        <div className="section">
          <div className="top_section">
            <div className="title_top">{apt.name}</div>
            <div className="button_top" onClick={onClose}><SVG_Arrow /></div>
          </div>
        </div>
      </div>
      <div className="pre_section" style={{ zIndex:8 }}>
        <div className="section">
          <table style={{ flex:1, background:'#fff', borderCollapse:'collapse', borderStyle:'hidden' }}>
            {rows.map(([label, value]) => (
              <tr key={label}>
                <td style={{ ...tdStyle, width:'50%' }}>{label}</td>
                <td style={tdStyle}>{value}</td>
              </tr>
            ))}
          </table>
        </div>
      </div>
      <div className="pre_section" style={{ zIndex:8 }}>
        <div className="section">
          <div className="top_section">
            <div className="dropdown" onClick={() => { onFavorite(apt.id); onCompare() }}>
              {apt.favorite ? 'Porównaj' : 'Polub i porównaj'}
            </div>
            <a className="dropdown" href={`/karty/${apt.name[1]} ${apt.name}.pdf`}
              download={`${apt.name[1]} ${apt.name}.pdf`} style={{ textDecoration:'none' }}>
              Pobierz kartę lokalu
            </a>
          </div>
          <div className="top_section" style={{ marginTop:'0.5rem' }}>
            <a href={`https://thesea.pl/formularz-kontaktowy/?ref=${apt.name}`} target="_blank" rel="noreferrer"
              className="dropdown" style={{ color:'#fff', background:'#C3A478', border:'none', textDecoration:'none' }}>
              Zapytaj
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}

function ComparePanel({ favorites, onClose, onPreview }) {
  const headStyle = { ...tdStyle, background:'#f3f3f3', fontWeight:600, width:200 }
  const colStyle  = { ...tdStyle, width:200 }
  return (
    <div style={{ width:'100%', height:'100vh', display:'flex', flexDirection:'column', background:'#f3f3f3', overflow:'auto' }}>
      <div className="pre_section" style={{ position:'sticky', top:0, zIndex:10 }}>
        <div className="section">
          <div className="top_section">
            <div className="title_top">Ulubione</div>
            <div className="button_top" onClick={onClose}><SVG_Arrow /></div>
          </div>
        </div>
      </div>
      <div className="pre_section" style={{ paddingBottom:'0.5rem' }}>
        <div className="section">
          <div className="top_section" style={{ overflow:'auto' }}>
            <table style={{ flex:1, width:'max-content', background:'#fff', borderCollapse:'collapse', borderStyle:'hidden' }}>
              <tbody>
                <tr>
                  <td style={headStyle} />
                  {favorites.map(a => <td key={a.id} style={colStyle}>{a.name}</td>)}
                </tr>
                {[['Budynek',a=>a.building],['Powierzchnia',a=><>{a.size} m<sup>2</sup></>],['Piętro',a=>a.floor],['Pokoje',a=>a.rooms]].map(([label,render])=>(
                  <tr key={label}>
                    <td style={headStyle}>{label}</td>
                    {favorites.map(a => <td key={a.id} style={colStyle}>{render(a)}</td>)}
                  </tr>
                ))}
                <tr>
                  <td style={headStyle} />
                  {favorites.map(a => (
                    <td key={a.id} style={colStyle}>
                      <img src={`/miniaturki/${a.name}.png`} style={{ width:'100%', objectFit:'contain' }} alt={a.name} />
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={headStyle} />
                  {favorites.map(a => (
                    <td key={a.id} style={colStyle}>
                      <div className="top_section" style={{ marginTop:'0.5rem' }}>
                        <div className="dropdown" onClick={() => a.available && onPreview(a)}>Zobacz</div>
                      </div>
                      <div className="top_section" style={{ marginTop:'0.5rem' }}>
                        <a href={`https://thesea.pl/formularz-kontaktowy/?ref=${a.name}`} target="_blank" rel="noreferrer"
                          className="dropdown" style={{ color:'#fff', background:'#C3A478', border:'none', textDecoration:'none' }}>
                          Zapytaj
                        </a>
                      </div>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  )
}

function CheckFilter({ label, active, onClick }) {
  return (
    <div className="filter_container" style={{ justifyContent:'center' }}>
      <div className="filter_header" style={{ marginBottom:0 }}>
        <div style={{ width:'100%' }}>
          {label}
          <div style={{ float:'right', height:20, width:20, border:'1px solid #ddd', borderRadius:4,
            cursor:'pointer', background: active ? '#c3a478' : '#fff' }} onClick={onClick}>
            <SVG_Check style={{ height:18, width:18, margin:1, fill:'#fff' }} />
          </div>
        </div>
      </div>
    </div>
  )
}

function FilterPanel({ filters, building, buildingDropdown, setBuildingDropdown, listType, setListType,
  apartments, clearFilters, onBuildingChange, onSliderChange, onCheckChange, onClearFilters,
  onPreview, onFavorite, onCompare }) {

  const count      = apartments.length
  const countLabel = count === 1 ? 'apartament' : endsWith234(count) ? 'apartamenty' : 'apartamentów'

  return (
    <div style={{ width:500, height:'100vh', display:'flex', flexDirection:'column', background:'#f3f3f3', overflow:'auto' }}>
      {/* Title */}
      <div className="pre_section" style={{ position:'sticky', top:0, zIndex:10 }}>
        <div className="section">
          <div className="top_section">
            <div className="title_top" style={{ fontFamily:"'Montserrat', sans-serif", fontWeight:400, letterSpacing:2 }}>THE SEA</div>
            <div className="button_top" onClick={onCompare}><SVG_Heart /></div>
          </div>
        </div>
      </div>
      {/* Building picker */}
      <div className="pre_section" style={{ zIndex:8 }}>
        <div className="section">
          <div className="top_section" style={{ position:'relative' }}>
            <div className="dropdown" onClick={() => setBuildingDropdown(v => !v)}>{building}&nbsp;▾</div>
            {buildingDropdown && (
              <div className="dropdown" style={{ position:'absolute', width:'100%', flexDirection:'column', top:'calc(100% + 5px)' }}>
                {['Wybierz budynek','Budynek A','Budynek B'].map(opt => (
                  <div key={opt} style={{ flex:1, padding:'0.5rem' }} onClick={() => onBuildingChange(opt)}>
                    {opt === 'Wybierz budynek' ? 'Obydwa budynki' : opt}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Sliders */}
      <div className="pre_section" style={{ zIndex:5 }}>
        <div className="section">
          <div className="filter_section">
            {[
              {label:'Powierzchnia', key:'size',  min:25, max:120, id:1},
              {label:'Liczba pokoi', key:'rooms', min:1,  max:4,   id:2},
              {label:'Piętro',       key:'floor', min:0,  max:3,   id:3},
            ].map(({ label, key, min, max, id }) => (
              <div key={key} className="filter_container">
                <div className="filter_header">
                  <div>{label}</div>
                  <div className="filter_header_heavy">{filters[key].join('-')}</div>
                </div>
                <StyledSlider defaultValue={filters[key]} min={min} max={max}
                  renderTrack={SliderTrack} renderThumb={SliderThumb}
                  onAfterChange={v => onSliderChange(id, v)} />
              </div>
            ))}
            <CheckFilter label="Ulubione"     active={filters.favorite} onClick={() => onCheckChange('favorite')} />
            <CheckFilter label="Z parkingiem" active={filters.parking}  onClick={() => onCheckChange('parking')}  />
            {clearFilters && (
              <div className="filter_container" style={{ justifyContent:'center' }}>
                <div className="filter_header" style={{ marginBottom:0 }}>
                  <div style={{ width:'100%' }}>
                    <div className="button_top" style={{ width:150, display:'flex', alignItems:'center' }} onClick={onClearFilters}>
                      Wyczyść filtry
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Count + view toggle */}
      <div className="pre_section" style={{ position:'sticky', top:64, zIndex:10, paddingBottom:'0.5rem' }}>
        <div className="section">
          <div className="top_section">
            <div className="title_top">{count}&nbsp;<span style={{ fontWeight:500 }}>{countLabel}</span></div>
            <div className="button_top" style={{ width:150, display:'flex', alignItems:'unset' }}>
              {['Karty','Lista'].map(type => (
                <div key={type} onClick={() => setListType(type)}
                  style={{ flex:1, textAlign:'center', borderRadius:'0.5rem', alignContent:'center',
                    color: listType===type ? '#fff' : '#000',
                    background: listType===type ? '#C3A478' : '#fff' }}>
                  {type}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {/* Apartment list */}
      <div className="pre_section" style={{ paddingTop:0, paddingBottom:'0.5rem' }}>
        <div className="section">
          {listType === 'Lista'
            ? <ApartmentTable apartments={apartments} onPreview={onPreview} onFavorite={onFavorite} />
            : <ApartmentCards apartments={apartments} onPreview={onPreview} onFavorite={onFavorite} />
          }
        </div>
      </div>
    </div>
  )
}

function ApartmentTable({ apartments, onPreview, onFavorite }) {
  return (
    <table style={{ width:'100%', background:'#fff', borderCollapse:'collapse', borderStyle:'hidden' }}>
      <thead>
        <tr>
          {['Apartament','Powierzchnia','Piętro','Pokoje','Ulub.'].map(h => (
            <td key={h} style={{ ...tdStyle, background:'#f3f3f3', fontWeight:600 }}>{h}</td>
          ))}
        </tr>
      </thead>
      <tbody>
        {apartments.map(a => (
          <tr key={a.id} onClick={() => a.available && onPreview(a)} style={{ cursor: a.available ? 'pointer' : 'default' }}>
            <td style={tdStyle}>{a.name}</td>
            <td style={tdStyle}>{a.size} m²</td>
            <td style={tdStyle}>{a.floor}</td>
            <td style={tdStyle}>{a.rooms}</td>
            <td style={tdStyle} onClick={e => { e.stopPropagation(); onFavorite(a.id) }}>
              <SVG_Heart style={a.favorite ? { fill:'#f00' } : {}} />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

function ApartmentCards({ apartments, onPreview, onFavorite }) {
  return apartments.map(a => (
    <div key={a.id} className="border_hover"
      style={{ width:'100%', background:'#fff', display:'flex', cursor: a.available ? 'pointer' : 'default', borderColor: a.available ? '' : 'transparent' }}
      onClick={() => a.available && onPreview(a)}>
      <img src={`/miniaturki/${a.name}.png`} style={{ flex:1, width:'50%', objectFit:'contain' }} alt={a.name} />
      <table style={{ flex:1, background:'#fff', borderCollapse:'collapse', borderStyle:'hidden' }}>
        <tbody>
          {[['Apartament',a.name],['Powierzchnia',<>{a.size} m<sup>2</sup></>],['Piętro',a.floor],['Pokoje',a.rooms]].map(([label,value])=>(
            <tr key={label}>
              <td style={{ ...tdStyle, width:'50%' }}>{label}</td>
              <td style={tdStyle}>{value}</td>
            </tr>
          ))}
          <tr>
            <td style={tdStyle}>Ulubiony</td>
            <td style={tdStyle} onClick={e => { e.stopPropagation(); onFavorite(a.id) }}>
              <SVG_Heart style={a.favorite ? { fill:'#f00' } : {}} />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  ))
}

// ─── Main App ─────────────────────────────────────────────────────────────────

export default function App() {

  const [apartments, setApartments] = useState(() => {
    const ids = JSON.parse(Cookies.get('favorite') ?? '[]')
    return applyFavorites(APARTMENTS, ids) // fallback to local data until API responds
  })

  useEffect(() => {
    axios.get('/api/apartments').then(response => {
      const ids = JSON.parse(Cookies.get('favorite') ?? '[]')
      setApartments(applyFavorites(response.data, ids)) // replace with live data, keeping favorites
    }).catch(() => {
      // silently keep the local APARTMENTS fallback on error
    })
  }, [])


  // const [apartments,   setApartments]   = useState(() => {
  //   const ids = JSON.parse(Cookies.get('favorite') ?? '[]')
  //   return applyFavorites(APARTMENTS, ids)
  // })
  const [filters,      setFilters]      = useState({ ...DEFAULT_FILTERS })
  const [building,     setBuilding]     = useState('Wybierz budynek')
  const [buildingDD,   setBuildingDD]   = useState(false)
  const [listType,     setListType]     = useState('Karty')
  const [clearFilters, setClearFilters] = useState(false)
  const [scopedFloor,  setScopedFloor]  = useState(null)
  const [preview,      setPreview]      = useState(null)
  const [compare,      setCompare]      = useState(false)
  const [tooltip,      setTooltip]      = useState({ visible:false, text:'', x:0, y:0 })
  const [dimensions,   setDimensions]   = useState({ width:0, height:0 })




  const imgRef  = useRef(null)
  const imgRef2 = useRef(null)

  const updateDims = useCallback((ref) => {
    if (ref.current) setDimensions({ width:ref.current.clientWidth, height:ref.current.clientHeight })
  }, [])

  useEffect(() => {
    const onResize = () => updateDims(scopedFloor ? imgRef2 : imgRef)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [updateDims, scopedFloor])

  const filtered = applyFilters(apartments, filters, building)

  const showTooltip = useCallback((e, text) => setTooltip({ visible:true, text, x:e.clientX, y:e.clientY - 25 }), [])
  const hideTooltip = useCallback(() => setTooltip(t => ({ ...t, visible:false })), [])

  const handleFavorite = useCallback((id) => {
    const saved = Cookies.get('favorite')
    let ids = saved ? JSON.parse(saved) : []
    ids = ids.includes(id) ? ids.filter(x => x !== id) : [...ids, id]
    Cookies.set('favorite', JSON.stringify(ids))
    setApartments(prev => applyFavorites(prev, ids))
  }, [])

  const handleBuildingChange = useCallback((b) => {
    setBuildingDD(false); setBuilding(b); setClearFilters(true)
  }, [])

  const handleSliderChange = useCallback((id, value) => {
    setClearFilters(true)
    setFilters(prev => {
      const u = { ...prev }
      if (id===1) u.size  = value
      if (id===2) u.rooms = value
      if (id===3) u.floor = value
      return u
    })
  }, [])

  const handleCheckChange = useCallback((key) => {
    setClearFilters(true)
    setFilters(prev => ({ ...prev, [key]:!prev[key] }))
  }, [])

  const handleClearFilters = useCallback(() => {
    setFilters({ ...DEFAULT_FILTERS }); setBuilding('Wybierz budynek')
    setScopedFloor(null); setClearFilters(false)
  }, [])

  const handleSelectFloor = useCallback((b, floor) => {
    setScopedFloor([b, floor]); setBuilding(`Budynek ${b}`)
    setClearFilters(true); setFilters(prev => ({ ...prev, floor:[floor, floor] }))
  }, [])

  const handleBackFromFloor = useCallback(() => {
    setScopedFloor(null); setBuilding('Wybierz budynek')
    setFilters(prev => ({ ...prev, floor:DEFAULT_FILTERS.floor }))
  }, [])

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+SC:wght@400;600&family=Montserrat:wght@300&display=swap');
        body { font-family: 'Cormorant SC', serif; }
        .button_top { width:35px; height:35px; border:1px solid #ddd; border-radius:8px; cursor:pointer; display:flex; align-items:center; justify-content:center; }
        .title_top  { align-items:center; color:#292929; display:flex; flex:1; font-size:25px; font-weight:700; line-height:1; margin:0 .25em; min-height:40px; position:relative; }
        .top_section { align-items:center; display:flex; gap:.25em; justify-content:space-between; margin:0; position:relative; }
        .section    { border-radius:.5rem; background-color:#fff; padding:.5rem; }
        .pre_section { padding:.5rem .5rem 0 .5rem; background:#f3f3f3; }
        .border_hover { border:1px solid transparent; cursor:pointer; }
        .border_hover:hover { border:1px solid #ccc; }
        .dropdown   { align-items:center; background-color:#fff; border:1px solid #ccc; border-radius:.5em; cursor:pointer; display:flex; flex:1; justify-content:center; min-height:2.5em; text-align:center; }
        .filter_section { background-color:#fff; display:flex; flex-wrap:wrap; gap:.5em; min-width:100%; position:relative; width:100%; }
        .filter_container { flex-grow:1; border-radius:.5rem; color:#666; display:flex; flex-direction:column; gap:0.5rem; min-height:40px; padding:.5em; width:calc(50% - 1.75rem); }
        .filter_header { display:flex; flex-direction:row; flex-wrap:wrap; gap:.25em; justify-content:space-between; margin-bottom:5px; font-size:18px; }
        .filter_header_heavy { font-weight:700; }
        tr:nth-child(odd) { background:#f3f3f3; }
      `}</style>

      <div style={{ width:'100vw', height:'100vh', display:'flex', background:'#f3f3f3', overflow:'hidden' }}>

        {/* Left panel */}
        {preview ? (
          <div style={{ flex:1, position:'relative' }}>
            <iframe src={`/karty/${preview.name[1]} ${preview.name}.pdf#toolbar=0`}
              style={{ border:'none', width:'100%', height:'100%' }} title={preview.name} />
          </div>
        ) : compare ? null : (
          <div style={{ flex:1, position:'relative', placeSelf:'center' }}>
            {scopedFloor ? (
              <>
                <div className="button_top"
                  style={{ position:'absolute', top:'calc(50% - 20px)', right:'1rem', width:40, height:40,
                    background:'#C3A478', border:'none', zIndex:100 }}
                  onClick={handleBackFromFloor}>
                  <SVG_Arrow style={{ width:32, height:32, fill:'#fff' }} />
                </div>
                <img src={`/pietra/${scopedFloor.join('')}.png`} ref={imgRef2}
                  onLoad={() => updateDims(imgRef2)}
                  style={{ width:'100%', height:'auto', display:'block' }}
                  alt={`Floor ${scopedFloor.join('')}`} />
                <FloorMap scopedFloor={scopedFloor} dimensions={dimensions} apartments={apartments}
                  onPreview={setPreview} onTooltip={showTooltip} onTooltipHide={hideTooltip} />
              </>
            ) : (
              <BuildingOverview imgRef={imgRef} onLoad={() => updateDims(imgRef)} onSelectFloor={handleSelectFloor} />
            )}
            {tooltip.visible && (
              <div style={{ position:'absolute', left:tooltip.x, top:tooltip.y, color:'#fff',
                padding:'4px 8px', borderRadius:4, fontSize:14, fontWeight:'bold', background:'#333',
                pointerEvents:'none', whiteSpace:'nowrap', transform:'translate(-50%,-50%)' }}>
                {tooltip.text}
              </div>
            )}
          </div>
        )}

        {/* Right panel */}
        {preview ? (
          <PreviewPanel apt={preview} onClose={() => setPreview(null)}
            onCompare={() => { setCompare(true); setPreview(null) }}
            onFavorite={handleFavorite} />
        ) : compare ? (
          <ComparePanel favorites={filtered.filter(a => a.favorite)}
            onClose={() => setCompare(false)}
            onPreview={a => { setPreview(a); setCompare(false) }} />
        ) : (
          <FilterPanel filters={filters} building={building} buildingDropdown={buildingDD}
            setBuildingDropdown={setBuildingDD} listType={listType} setListType={setListType}
            apartments={filtered} clearFilters={clearFilters}
            onBuildingChange={handleBuildingChange} onSliderChange={handleSliderChange}
            onCheckChange={handleCheckChange} onClearFilters={handleClearFilters}
            onPreview={setPreview} onFavorite={handleFavorite} onCompare={() => setCompare(true)} />
        )}

      </div>
    </>
  )
}